module.exports = __webpack_public_path__ + "static/pic02-cbfdab55de353acb0a6545f87e7162e1.jpeg";